module.exports = __webpack_public_path__ + "img/icon-sort-up-active.a18356bd.svg";